import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',

    paddingHorizontal: 53,
    paddingTop: 53,
    paddingBottom: 53,
    backgroundColor: 'white',
  },

  fullWidthContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },

  pageTitle: {
    alignSelf: 'flex-start',
    fontSize: 40,
    fontWeight: 700,
    fontFamily: 'Lato',
    textTransform: 'uppercase',
    color: 'black',
  },

  galleryContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 10,
    rowGap: 20,
    width: '100%',
  },

  logoImage: {
    width: 125,
    height: 55,
    objectFit: 'cover',
    margin: 5,
  },
});
